
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


/**
 * Base UI Components to be imported, 
 * this mandatory to be included so that the View Module Pages can be rendered via baseUI
 */
import { BaseUIContainerComponent } from '../../../BaseFramework/base-ui/base-ui-container/base-ui-container.component'
import { AppLayoutComponent } from '../../../BaseFramework/base-ui/app-layout/app-layout.component'
////BASEUI Modules End


import { from } from 'rxjs';
import { ClaimsAuthenticationGuard } from '../../Claims';
import { SearchProposalComponent } from './search-proposal/search-proposal.component';
import { FwaDashboardComponent } from '../../shared-components/fwa-dashboard/fwa-dashboard.component';
import { TransactionProposalDetailsComponent } from './transaction-proposal/transaction-proposal-details.component';
import { ReceiptingComponent } from '../../shared-components/receipting/receipting.component';
import { SearchReceiptComponent } from '../../shared-components/search-receipt/search-receipt.component';
import { SLADashboardComponent } from '../../shared-components/sla-dashboard/sla-dashboard.component';
import { UWDashboardComponent } from '../../shared-components/uw-dashboard/uw-dashboard.component';
import { UnderWriterDashboardComponent } from 'app/ViewModules/shared-components/under-writer-dashboard/under-writer-dashboard.component';
import { IntimationBulkUploadComponent } from 'app/ViewModules/shared-components/intimation-bulk-upload/intimation-bulk-upload.component';
import { NewBulkComponent } from 'app/ViewModules/shared-components/new-bulk/new-bulk.component';
import { ProcessBulkUploadComponent } from 'app/ViewModules/shared-components/process-bulk-upload/process-bulk-upload.component';
import { ApiDashboardComponent } from 'app/ViewModules/shared-components/api-dashboard/api-dashboard.component';
import { NBDashboardComponent } from '../../shared-components/nb-dashboard/nb-dashboard.component';
import { ReportsComponent } from './reports/reports.component';
import { OcrCaseCreationComponent } from 'app/ViewModules/shared-components/ocr-case-creation/ocr-case-creation.component';
var routeList = [
    {
        path: 'search',
        component: SearchProposalComponent,
        data: {
            breadcrumb: 'Search Proposal',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'report',
        component: ReportsComponent,
        data: {
            breadcrumb: 'Report',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'receipting',
        component: SearchReceiptComponent,
        data: {
            breadcrumb: 'Receipt',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'receiptingForm',
        component: ReceiptingComponent,
        data: {
            breadcrumb: 'Receipt',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'uw-dashboard',
        component: UWDashboardComponent,
        data: {
            breadcrumb: 'UW Dashboard',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'nb-dashboard',
        component: NBDashboardComponent,
        data: {
            breadcrumb: 'New Business Dashboard',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'fwa-dashboard',
        component: FwaDashboardComponent,
        data: {
            breadcrumb: 'FWA Dashboard',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'sla-dashboard',
        component: SLADashboardComponent,
        data: {
            breadcrumb: 'SLA Dashboard',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'search-branch',
        component: SearchProposalComponent,
        data: {
            breadcrumb: 'Search Branch Intimation',
            intimationType: 'BRANCH'
        },
    },
    {
        path: 'transaction',
        component: TransactionProposalDetailsComponent,
        data: {
            breadcrumb: 'Intimation Transaction'
        },
    },
    {
        path: 'under-writer-dashboard',
        component: UnderWriterDashboardComponent,
        data: {
            breadcrumb: 'UW Dashboard',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'bulkUpload',
        component: IntimationBulkUploadComponent,
        data: {
            breadcrumb: 'Bulk Upload',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'newBulk',
        component: NewBulkComponent,
        data: {
            breadcrumb: 'New Bulk',
            intimationType: 'NONBRANCH'
        },
    },
    {
        path: 'processBulk',
        component: ProcessBulkUploadComponent,
        data: {
            breadcrumb: 'New Bulk',
            intimationType: 'NONBRANCH'
        },
    },
    
    {
        path: 'api-dashboard',
        component: ApiDashboardComponent,
        data: {
            breadcrumb: 'API Dashboard',
        },
    },
    {
        path: 'caseWithOCR',
        component: OcrCaseCreationComponent,
        data: {
            breadcrumb: 'Generate with OCR',
            intimationType: 'NONBRANCH'
        },
    },
    // {app/nbu/proposal/search
    //     path: 'bulkUpload',
    //     component: ProposalBulkUploadComponent,
    //     data: {
    //         breadcrumb: 'Intimation Bulk Upload',
    //         intimationType: 'NONBRANCH'
    //     },
    // },
    // {
    //     path: 'newBulk',
    //     component: NewBulkComponent,
    //     data: {
    //         breadcrumb: 'New Bulk',
    //         intimationType: 'NONBRANCH'
    //     },
    // },


];

const routes: Routes = [
    ...routeList
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class NewProposalRoutingModule { } 
